import { styled } from '@mui/material';

export const Div = styled('div')({});
